// Generated by CoffeeScript 2.7.0
var ReceiptTaggables;

import TagsListContainer from 'trunks/vue/admin/compositions/tags_groups/tags_list_container.js';

import Paginator from 'trunks/vue/admin/components/paginator.js';

export default ReceiptTaggables = Vue.extend({
  components: {
    'tag-list-container': TagsListContainer,
    paginator: Paginator
  },
  props: {
    tag: {
      type: Object
    }
  },
  data: function() {
    return {
      doRequestUrl: `/admin/tags/${this.tag.id}/taggables`,
      receiptList: []
    };
  },
  template: `<tag-list-container extendClass="receipt-taggables main-content-list-container">
  <template slot="title">
    <div class="list-title">
      <button  class="text-btn btn-primary mr-3" @click="goToTagGoups">
        <i class="slp-arrow-left primary"></i>
      </button>
      <span>{{ tag.name }}</span>
    </div>
  </template>
  <div slot="content" class="datable-table">
    <div class="table-responsive receipt-table">
      <table class="table table-noborder table-striped">
        <thead>
          <tr>
            <th>消息类型</th>
            <th>消息名称</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="receipt in receiptList">
            <tr class="table-row" @click="_goToTargetUrl(receipt)">
              <td><div class="row-cell text-ellipsis">{{ receipt.type_text }}</div></td>
              <td class="row-cell"><div class="row-cell text-ellipsis">{{ receipt.title }}</div></td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <paginator  :resourceUrl='doRequestUrl'
                @dataReceived="updateRecords"
                ref='paginator' />
  </div>
</tag-list-container>`,
  created: function() {
    return Turbolinks.clearCache();
  },
  mounted: function() {
    return this.$refs.paginator.go();
  },
  methods: {
    updateRecords: function(data) {
      return this.receiptList = this._parseRecieptList(data);
    },
    goToTagGoups: function() {
      return Turbolinks.visit(`/admin/tag_groups/receipt/${this.tag.tag_group_id}`);
    },
    _parseRecieptList: function(data) {
      return _.map(data, function(receipt) {
        switch (receipt.type) {
          case 'Form':
            receipt.type_key = 'forms';
            receipt.type_text = '表单';
            break;
          case 'Post':
            receipt.type_key = 'posts';
            receipt.type_text = '消息';
            break;
          case 'TemplatePost':
            receipt.type_key = 'template_posts';
            receipt.type_text = '模板消息';
        }
        return receipt;
      });
    },
    _goToTargetUrl: function(receipt) {
      return window.open(`/admin/${receipt.type_key}/${receipt.id}`);
    }
  }
});
